import React from "react";

interface ProfileLikeChipIconProps {
  className?: string;
}

function ProfileLikeChipIcon({ className }: ProfileLikeChipIconProps) {
  return (
    <svg
      className={className}
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M14.4497 0.953651C13.6055 0.269813 12.5328 -0.066948 11.4494 0.0117612C10.366 0.0904703 9.35315 0.578748 8.61656 1.37743L8.00091 2.01169L7.38526 1.37743C6.64885 0.578447 5.63596 0.0899547 4.55246 0.0112385C3.46896 -0.0674778 2.39615 0.269489 1.55208 0.953651C1.09217 1.35166 0.717893 1.839 0.451964 2.3861C0.186035 2.9332 0.0339977 3.52865 0.00507886 4.13631C-0.0238399 4.74397 0.0709627 5.35118 0.283733 5.92108C0.496504 6.49097 0.822806 7.01168 1.24284 7.4516L7.29206 13.6995C7.38349 13.7945 7.49314 13.8701 7.61446 13.9218C7.73577 13.9734 7.86625 14 7.99809 14C8.12992 14 8.2604 13.9734 8.38172 13.9218C8.50303 13.8701 8.61268 13.7945 8.70411 13.6995L14.7533 7.4516C15.1741 7.01225 15.5011 6.49189 15.7146 5.92217C15.9281 5.35244 16.0235 4.74524 15.9951 4.13747C15.9667 3.52969 15.8151 2.93404 15.5494 2.38672C15.2838 1.8394 14.9096 1.35183 14.4497 0.953651Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ProfileLikeChipIcon;
